import { StyleSheet, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width: SCREEN_WIDTH } = Dimensions.get('screen')

export default StyleSheet.create({
  container: theme => ({
    flex: 1,
    overflow: 'hidden',
    backgroundColor: theme.colors.cardBackgroundColorThree,
  }),
  verticalLabelsViewStyle: {
    flexDirection: 'row',
    paddingBottom: 16,
    alignItems: 'flex-end',
    // alignSelf: 'flex-end',
    justifyContent: 'space-between',
    height: 34,
    paddingRight: 20
  },
  verticalLabelsTextStyle: theme => ({
    width: 25,

    fontSize: 14.6,
    color: theme.colors.borderColorSeven,
    textAlign: 'center',
  }),
  activeVerticalLabelsTextStyle: theme => ({
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  deactiveVerticalLabelsTextStyle: theme => ({
    color: theme.colors.buttons.disabledThree,
  }),
  horizontalLine: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.fillColor,
    width: '100%',
  }),
  barsViewStyle: {
    marginLeft: 10,
    marginTop: 43,
    height: 86,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingRight: 20
  },
  barsViewMarginBottom: {
    marginBottom: 15,
  },
  singleBarViewStyle: {
    width: 15,
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
  },
  singleBarMarginBottom: {
    bottom: -12,
    height: '50%',
  },
  pressAreaStyle: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  yearStyle: colors => ({
    color: colors.usagePercentage,
    fontSize: 14.6,
    textAlign: 'center',
    fontWeight: 'bold',
  }),
  yearStyleContainer: {
    width: 36,
    height: 18,
    position: 'absolute',
    bottom: 5,
    right: 18,
    transform: [{ rotate: '-90deg' }]
  },
  zeroBillContainer: {
    height: '100%',
    justifyContent: 'flex-end',
  },
  zeroBill: {
    height: 1,
    width: 8,
    borderRadius: 6,
    backgroundColor: Colors.vfRed,
  },
  zeroBillDisabled: {
    backgroundColor: Colors.veryLightPinkTwo,
  },
  seeBarBillTitle: theme => ({
    fontSize: 14,
    color: theme.colors.textColorTwo,
    marginBottom: 2,
  }),
  seeBarBillSubTitle: (theme, isAvailableBill) => ({
    fontSize: isAvailableBill ? 14 : 13,
    color: theme.colors.textColorThree,
    marginBottom: 4,
    ...Fonts.type.bold,
  }),
  seeBarBillButton: theme => ({
    fontSize: 14,
  }),
  seeBarBillButtonNegativeBill: {
    marginTop: 10,
    marginBottom: -11,
  },
  seeBarBillContainer: length => ({
    position: 'absolute',
    width: 90,
    left: length === 0 ? 27 : (length * 15 + 20),
    bottom: 0,
    height: 100,
  }),
  seeBarBillBottom: {
    bottom: 28,
  },
  seeBarBillWithNegativeBill: {
    bottom: 14,
  },
  yearMargin: { marginLeft: 36 },
  billsPerMonthContainer: length => ({
    width: length * 15 + 20,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'flex-end'
  }),
  line: theme => ({
    width: '100%',
    height: 1,
    backgroundColor: theme.colors.borderColorFour,
    marginRight: -20,
    marginVertical: 14,
  })
});
